<div class="inline-spinner-container">
    <div class="d-flex flex-row">
        <div class="sp sp-circle"></div>
    </div>
</div>